
const BannerData = {
  videoUrl: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2F6_sec_m.mp4?alt=media&token=2b7b975f-c48e-4e55-bc01-1b90305cc013",
  title: "The Carens Clavis EV",
  subtitle: "It’s an E.We",
  price: "₹17 99 000*",
  features: [
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fps1.avif?alt=media&token=63da9291-2107-4f0a-b907-fa701c8aa760",
      text: "Paddle Shifters for i-Pedal & Regenerative braking",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fps2.avif?alt=media&token=2ce9c052-3392-4181-b020-1b8b5c03e8fd",
      text: "7-seater cabin",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fps3.avif?alt=media&token=52de883a-3a55-4a13-a565-772010711f21",
      text: "Vehicle to Load (V2L)",
    },
  ],
};

const caroData = [
  {
    cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Ffast%20charge.webp?alt=media&token=a7121129-a095-4d99-93c5-4deec6296b64",
    type: "imgbanner",
    title: " ",
    subtitle: " ",
    mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2Fclavis-m_1.jpg.jpeg?alt=media&token=50b3f550-703c-4179-a3a4-14dfc791924a"
  },
  // {
  //   cover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Flogo2.avif?alt=media&token=7ba7f718-d8e9-4e7c-9119-731b717152a1",
  //   type: "imgbanner",
  //   title: " ",
  //   subtitle: " ",
  // },
  // {
  //     cover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2FSec3-d.avif?alt=media&token=be2c2035-7638-4f65-89de-eb5955b89203",
  //     type: "imgbanner",
  //     title: " ",
  //     subtitle: " ",
  // },
]

const CircleData = [
  {
    title: "Ivory Silver Matte",
    color: "#a9a59c",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fism.webp?alt=media&token=d0e329ee-1fa6-478e-9c8f-7f33b750ea4d",
  },
  {
    title: "Glacier White Pearl",
    color: "#f1fafb",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fism2.webp?alt=media&token=b3d82683-7e7f-491f-9fea-086190deb317",
  },
  {
    title: "Pewter Olive",
    color: "#3b493c",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fism3.webp?alt=media&token=20bf6852-cfc5-4f7f-856b-b84f72f544b2",
  },
  {
    title: "Aurora Black Pearl",
    color: "#131617",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fism4.webp?alt=media&token=3f89bae9-5d2a-455c-8678-cf73b0977cbe",
  },
  {
    title: "Imperial Blue",
    color: "#2a2c71",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fism5.webp?alt=media&token=798720bf-da9f-4114-b74b-313e4f757e0f",
  },
  {
    title: "Gravity Grey",
    color: "#35373a",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fism6.webp?alt=media&token=e61c2d1a-640f-4622-9f69-104c154c9e69",
  },
];

const TrimData = [
  {
    title: "HTK+",
    cost: "17,99,000",
    feature1: `Shift By Wire`,
    feature2: "Paddle Shifters for i-Pedal & Re-gen braking",
    feature3: "67.62 cm (26.62”) Dual Panoramic Display Panel",
    feature4: "Star Map LED Connected DRLs with Integrated Turn Signals",
    feature5: "Active Air Flap",
    feature6: "Smart Key with Motion Sensor & Remote Start",
    feature6: "Infotainment-Temperature control swap switch",

  },
  {
    title: "HTX",
    cost: "20,49,000",
    feature1: `ADAS Level 2 with 20 Autonomous Features`,
    feature2: "Dual Panoramic Sunroof",
    feature3: "Smartphone Wireless Charger",
    feature4: "Paddle Shifters for i-Pedal & Re-gen braking",
    feature5: "67.62 cm (26.62”) Dual Panoramic Display Panel",
    feature6: "64-Color Ambient Lighting & Footwell Lamp",
    feature6: "All windows auto up/down safety with Voice recognition ",

  },
{
    title: "HTX E",
    cost: "19,99,000",
    feature1: `Panoramic Sunroof`,
    feature2: "67.62 cm (26.62”) Dual Panoramic Display Panel",
    feature3: "Beige & Navy Leatherette seats",
    feature4: "Drive Mode Select [Eco/Normal/Sport]",
    feature5: "Smartphone Wireless Charger",
    feature6: "64-Color Ambient Lighting & Footwell Lamp",
    feature6: "Smart Pure Air Purifier with AQI Display ",

  },

  {
    title: "HTX ER",
    cost: "22,49,000",
    feature1: `R 17 - 43.66 cm (17”) Dual Tone Aero Alloy Wheels`,
    feature2: "Paddle Shifters for i-Pedal & Re-gen braking",
    feature3: "67.62 cm (26.62”) Dual Panoramic Display Panel",
    feature4: "Smartphone Wireless Charger",
    feature5: "Beige & Navy Leatherette seats ",
    feature6: "ADAS Level 2 with 20 Autonomous Features",
    feature7: "64-Color Ambient Lighting & Footwell Lamp",

  },
  {
    title: "HTX+ ER",
    cost: "24,49,000",
    feature1: `V2L - Vehicle To Load (Exterior & Interior)`,
    feature2: "67.62 cm (26.62”) Dual Panoramic Display Panel",
    feature3: "Beige & Navy Leatherette seats",
    feature4: "Dual Panoramic Sunroof",
    feature5: "ADAS Level 2 with 20 Autonomous Features",
    feature6: "BOSE Premium Sound System with 8 Speakers",
    feature7: "Paddle Shifters for i-Pedal & Re-gen braking",

  },
  {
    title: "HTX E ER",
    cost: "21,99,000",
    feature1: `51.4 kWh Battery (Extended Range)`,
    feature2: "Smart Pure Air Purifier with AQI Display",
    feature3: "R17-43.66 cm (17”) Dual Tone Aero Alloy Wheels",
    feature4: "64-Color Ambient Lighting & Footwell Lamp",
    feature5: "Beige & Navy Leatherette seats ",
    feature6: "Panoramic Sunroof",
    feature7: "Drive Mode Select [Eco/Normal/Sport]",

  },
]

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Book Your Clavis Ev Today",
    desc: "Its time to own the most inspiring Kia ever",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Learn more about its wild possibilities",
    link: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2FCarens_Clavis_EV_Page_Desktop.pdf?alt=media&token=a4fa0be8-c562-43ea-a69b-52cec9bde707",
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 0000000000",
    link: "tel:+919237386213",
  },
];

const caro3in1Data = [
  {
    image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcard1.jpg?alt=media&token=bb5c2495-dacb-4d7c-9faa-fd3b8a9557f4",
    title: '*ADAS Level-2 with 27 Autonomous Features ',
    desc: 'Ever vigilant and always ready to step in, the EV9 ensures the ultimate active and passive safety. With more than 27 *ADAS functions and a plethora of other features, everyone in and around the EV9 stays safe and in control.',
  },
  {
    image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcard2.jpg?alt=media&token=0c477af9-7b39-4d1c-9c12-cdd92deeb9f6",
    title: 'Digital Pattern Lighting Grille',
    desc: 'The sleek and muscular body of the EV9 features the Digital Pattern Lighting Grille with Intelligent Ice Cube LED Projection Headlamps; it certainly leaves a lasting impression on everyone.',
  },
  {
    image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcard3.jpg?alt=media&token=72646da0-34c4-499a-8a78-2b2acd95932b",
    title: 'Trinity Panoramic Display',
    desc: 'Technology is integrated seamlessly, and every element is chosen to provide a modern, and convenient driving experience. Navigate and control every drive with the dynamic 12.3” Instrument Cluster​ + 5” HVAC Controls ​+ 12.3” Touchscreen Navigation.',
  },
  {
    image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcard4.jpg?alt=media&token=30b31633-7265-48f4-8cc5-d88d721fb5da",
    title: 'Over the Air Software Updates​',
    desc: 'Let your vehicle evolve effortlessly with wireless upgrades.',
  },
  {
    image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcard5.jpg?alt=media&token=104f009c-62f7-4084-931e-f125ae029447",
    title: '2nd Row Captain Seats with Relaxation &amp; Massage Function',
    desc: 'The 2nd row captain seats with relaxation and massage functions transform your ride into a sanctuary. Experience customizable comfort and luxury, all the way',
  },
  {
    image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcard6.jpg?alt=media&token=8ab983af-9608-4bb5-b2fd-567a8275f67d",
    title: 'Dual Sunroof',
    desc: 'Embrace the open sky with the Kia EV9’s dual sunroof and enhance your connection with the world beyond.',
  },
  {
    image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcard7.jpg?alt=media&token=9997068f-da28-45bb-a6c7-12042f5f430f",
    title: 'Digital IRVM',
    desc: 'Experience enhanced visibility with the IRVMs integrated digital screen, offering a real-time rear camera view. Say goodbye to blind spots and enjoy safer, more confident driving, even in challenging conditions.',
  },

];

const gridData = [
  {
    type: 'img',
    item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fits1.avif?alt=media&token=f48e952b-f7c7-422d-aaa5-e864beff9efe",
  },
  {
    type: 'text',
    item1: "It’s an E.We",
    item2: "V2L (External + Internal)",
    item3: "More than a car, it’s a power source. Charge your gadgets on the move.",
  },
  {
    type: 'img',
    item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fits2.avif?alt=media&token=3646c4a8-8ecb-4b29-a464-c28858414af2",
  },
  {
    type: 'text',
    item1: "7-seater Cabin​",
    // item2: "Driver and Passenger Relaxation Seats",
    item3: "Designed to comfortably move families, friends, and everything in between.",
  },
  {
    type: 'img',
    item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fits3.avif?alt=media&token=772b1ce7-15e4-4592-95d5-b7a5b12b74cb",
  },
  {
    type: 'text',
    item1: "#ADAS Level 2 with 20 Autonomous Safety Features",
    // item2: "Driver and Passenger Relaxation Seats",
    item3: "From lane keep assist to collision avoidance, it’s tech that watches your back.",
  },
];

const com3struct = [
  {
    type: "text",
    backgroundColor: "#1d1d1d",
    color: "white",
    heading: "Commands the first glance. And the next.",
    url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fflsize.avif?alt=media&token=800dcbbc-3cfc-4605-9e56-afea95950c4e",
    description: [
      "With sculpted lines that exude presence from every angle and a confident SUV stance,the Carens Clavis EV turns first impressions into lasting ones.",
    ],
    height: {
      md: "70vh",
      sm: "42vh",
      xs: "22vh",
    },
  },
  {
    type: "cards",
    items: [
      {
        title: "Dual Pane Panoramic Sunroof",
        description: " Let the sunshine in! A wide, stunning view that brightens every family ride.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fpane1.webp?alt=media&token=8b79f081-4fa4-4841-b224-76aafc84d144",
      },
      {
        title: "Kia Digital Tiger Face with Grille Cover",
        description: "Command attention on every journey.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fpane2.webp?alt=media&token=0d795192-5aba-40db-b991-e78a2c6eb557",
      },
      {
        title: "Ice Cube MFR LED Headlamps",
        description: "Illuminate the road ahead with cutting-edge precision, ensuring your loved ones always travel in safety and style.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fpane3.webp?alt=media&token=f57eef21-4d5c-41cd-a397-fe738bf43361",
      },
      {
        title: "Star Map LED Connected Tail Lamps",
        description: "A signature look that lights the way, leaving an indelible impression.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fpane4.webp?alt=media&token=215a3d56-e3fc-4486-afd4-5a9da4b95065",
      },
      {
        title: "R17 43.66cm (17”) Crystal Cut Dual Tone Aero Alloy Wheels",
        description: "Designed to turn heads at every corner, these wheels will take your drive up a notch.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fpane5.webp?alt=media&token=8d4c2ff5-1ab6-4497-95f1-da8bc6ad5f53",
      },
    ],
  },

  {
    type: "image",
    backgroundColor: "#1d1d1d",
    color: "white",
    heading: "Invites you in. And lets you unwind.",
    url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fflsize2.webp?alt=media&token=6b7e066f-0f2c-4fbe-90cf-548d512e09f8",
    description: [
      "Inside, the Carens Clavis EV is crafted for ease, clarity and seamless connection,so everyone feels instantly at home. A sweeping panoramic display, shift-by-wire convenience,immersive Bose audio, and meticulous details blend technology with tranquility and spaciousness,turning every shared journey into a moment of effortless harmony.",
    ],
    height: {
      md: "70vh",
      sm: "42vh",
      xs: "22vh",
    },
  },
  {
    type: "cards",
    items: [
      {
        title: "67.62 cm (26.62”) Dual Panoramic Display Panel",
        description: "Navigate, control, and entertain with a seamless interface the whole family can enjoy.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fdisplay1.webp?alt=media&token=3498ff16-b3ac-4f36-bd13-0c5c78b5efc7",
      },
      {
        title: "Front Ventilated Seats",
        description: "Stay cool and composed during long drives or summer adventures.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fdisplay2.webp?alt=media&token=b9d16282-cfd7-4a4f-a24b-51febf5565ea",
      },


      {
        title: "Infotainment / Temperature Control Swap Switch",
        description: "Adjust climate settings with a simple switch for the full house.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fdisplay3.webp?alt=media&token=d5fa7654-2879-4725-a80c-aac78f2680fd",
      },
      {
        title: "Shift By Wire- Column Type",
        description: " Change gear position simply by turning the dial of shift-by-wire left or right.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fdisplay4.webp?alt=media&token=9d90f2a4-71d6-491b-8307-0cb7f89f603d",
      },
      {
        title: "Second Row Seat One Touch Easy Electric Tumble",
        description: "Enjoy seamless third-row access on every journey with just a touch ",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fdisplay5.webp?alt=media&token=3e6c34c1-0c47-424b-853a-052d5567bcd5",
      },
      {
        title: "BOSE Premium Sound System with 8 Speakers",
        description: " Turn every family drive into a concert on wheels with immersive sound that brings everyone together.",
        image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2Fs5-5.png.jpeg?alt=media&token=4700dae1-a6e7-45a9-8038-3ddc23cd4b19",
      },
      {
        title: "64 Color Ambient Light & Footwell Lamp",
        description: "Illuminate the cabin to match your mood, from night to day.",
        image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2Fs5-6.png.jpeg?alt=media&token=a460c193-8cb6-4738-8888-139a83629db2",
      },
      {
        title: "4-Way Power Driver Seat",
        description: "Drive with ease and confidence, whether it's the school run or a weekend trip.",
        image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2Fs5-8.png.jpeg?alt=media&token=337d6203-ea78-46da-99eb-1510c9d24642",
      },
      {
        title: "Smart Pure Air Purifier with AQI Display",
        description: " Breathe easy with your loved ones. This purifier keeps the cabin air fresh and safe, no matter where you drive. ",
        image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2Fs5-9.png.jpeg?alt=media&token=4f9841d4-9be7-48a2-a221-e5095dffa4a9",
      },
      {
        title: "Frunk with Cover (25l)",
        description: "Store more up front, extra covered space for your everyday essentials.",
        image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2Fs5-10.png.jpeg?alt=media&token=308c2b57-3364-4973-8b6f-0acbf3ef24a0",
      },

    ],
  },

  {
    type: "image",
    backgroundColor: "#1d1d1d",
    color: "white",
    heading: "Shares the power. And the future.",
    url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fflsize3.webp?alt=media&token=2df4a681-46ad-4dd1-8655-35b42607d81e",
    description: [
      "More than moving you, the Carens Clavis EV empowers your world. With V2L and V2V capabilities to charge your devices or even other EVs, and intelligent i-regen technology that recovers energy as you drive, every trip becomes smarter, smoother, and more sustainable.",
    ],
    height: {
      md: "80vh",
      sm: "60vh",
      xs: "40vh",
    },
  },
  {
    type: "cards",
    items: [
      {
        title: "V2L (External + Internal)​",
        description: " More than a car, it’s a power source. Charge your gadgets on the move.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fvl1.webp?alt=media&token=1d85096f-89c6-469f-877a-56d36d1357db",
      },
      {
        title: "Paddle Shifters for i-Pedal & Regenerative braking​",
        description: "Smooth, intuitive, and smart. Reclaim energy every time you slow down.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fvl2.webp?alt=media&token=b53467e0-bbda-4276-b25d-2083183ee755",
      },


    ],
  },

  {
    type: "image",
    backgroundColor: "#1d1d1d",
    color: "white",
    heading: "Eases the way. And the wait.",
    url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fflsize4.webp?alt=media&token=5a5d9de9-e56c-4b7a-925c-6a4ff1a7aa92",
    description: [
      "Your EV deserves a network that keeps up. With K-Charge integrated into the MyKia app, you have access to over 11,000 charging points across India, including more than 7000 AC chargers and 4000 DC fast chargers. From planning to payment, it is designed to make every stop seamless so you can simply enjoy the ride in the company of those who matter most.",
    ],
    height: {
      md: "80vh",
      sm: "60vh",
      xs: "40vh",
    },
  },
  {
    type: "cards",
    items: [
      {
        title: "11000+ Charging Points Nationwide",
        description: "Power up anywhere. Access charging points across India.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcharge1.webp?alt=media&token=f7cc7724-c516-4e3f-8090-4b1b926a4ea8",
      },
      {
        title: "18 leading charge Point Operators (CPOs) Integrated",
        description: "Stay seamlessly connected to India's top CPOs. ",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcharge2.webp?alt=media&token=0106144b-3058-4e4a-b0a6-d33b1cdc8ed4",
      },
      {
        title: "Fast EV charging Network Spanning PAN India",
        description: "Fast charging, everywhere you go, powered by a network that spans across India. ",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcharge3.webp?alt=media&token=652cca37-4b90-43ac-8985-97256a2dc8dc",
      },

    ],
  },

  {
    type: "image",
    backgroundColor: "#1d1d1d",
    color: "white",
    heading: "Safety for We.",
    url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fflsize5.webp?alt=media&token=1e16c8f9-8c9a-44c2-a40f-b5cefaa266dc",
    description: [
      "The Carens Clavis EV comes with #ADAS Level 2 with 20 autonomous features & 18 robust safety standard features.",
    ],
    height: {
      md: "80vh",
      sm: "60vh",
      xs: "40vh",
    },
  },
  {
    type: "cards",
    items: [
      {
        title: "Smart Cruise Control (SCC) with Stop & Go",
        description: "Automatically maintain distance and manage stop-and-go traffic.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcru1.webp?alt=media&token=ba613cd3-b942-470d-8765-7977c2306df2",
      },
      {
        title: "Forward Collision Warning and Avoidance Assist (FCW & FCA)",
        description: "Stay one step ahead and detect potential collisions.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcru2.webp?alt=media&token=08e5cc69-4db7-4de1-8b27-669f6bab7415",
      },
      {
        title: "6 Airbags as Standard",
        description: "Safeguard everyone on board with comprehensive protection on every drive. ",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcru3.webp?alt=media&token=3c01c7aa-351a-4be7-9751-b914891b957e",
      },
      {
        title: "Lane Keep Assist (LKA)",
        description: "Keeps you in your lane by providing steering assistance.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcru4.webp?alt=media&token=84ac674d-9b84-40e3-b70b-5e3955db0b70",
      },
      {
        title: "Rear Cross Traffic Collision Warning & Avoidance Assist (RCTA)",
        description: " Back out confidently with sensors that detect crossing vehicles and help you brake in time.",
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2Fcru5.webp?alt=media&token=12b0d45c-c582-4179-9b2c-d5f3a61992dd",
      },
      {
        title: "High Beam Assist (HBA)",
        description: " Light the road ahead without dazzling others, with HBA that automatically adjusts for safer night drives.",
        image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/newClavisEv%2Fs8-6.png.jpeg?alt=media&token=1328a703-1f90-4ee1-a12e-4795b89d5563",
      },


    ],
  },

]

const Caro3Heading = {
  heading: "Meet the 2024 World Car of the Year"
}
const FaqData = [
  {
    question: "What is the price of the Kia Carens Clavis EV Electric Car in India?",
    answer: "Kia Carens Clavis EV starts at price of ₹ 17 99 000*(Ex-showroom price all India).",
  },
  {
    question: "How many airbags are there in Kia Carens Clavis EV?",
    answer:
      "The Kia Carens Clavis EV prioritizes safety with standard 6 airbags. This comprehensive system includes Front Dual Airbags, Front Seat Side Airbags, and Side Curtain Airbags, ensuring robust protection for all occupants.",
  },
  {
    question: "How long does it take to charge the Kia Carens Clavis EV?",
    answer:
      "When utilizing an 11kW AC fast charger, the Kia Clavis EV's 42 kWh battery can be charged in 4 hours*, while its 51.4 kWh battery requires 4 hours and 45 minutes* for a full charge",
  },
  {
    question: "What is the range of New Kia Carens Clavis EV?",
    answer:
      "The new Kia Carens Clavis EV features two battery options: a 42 kWh variant with an estimated range of 404 km*, and a 51.4 kWh variant providing an estimated range of 490 km* per charge",
  },
  {
    question: "How many features does the Kia Carens Clavis EV offer in its ADAS system?",
    answer:
      "The Kia Carens Clavis EV comes with ADAS Level 2 along with 20 autonomous safety features designed to keep you and your family secure through every mile.",
  },

  {
    question: "How many color options are available for the Kia Clavis EV?",
    answer:
      "Kia Carens Clavis EV is available in 6 Monotone Colours like Ivory Silver Matt, Pewter Olive, Imperial Blue, Aurora Black Pearl, Glacier White Pearl, and Gravity Gray colours.",
  },
  {
    question: "What are the seating options available in the Kia Carens Clavis EV?",
    answer:
      "The Kia Carens Clavis EV is a spacious 7 seater electric car suitable to comfortably move families, friends, and everything in between.",
  },
];
const StepData = [
  {
    title: "Front Charging Port With LED Illumination",
    desc: "Easy to access, even in tight spots. Plugging in made simpler with a front-mounted charging port.",
  },
  {
    title: "Start Map LED Connected Tail Lamps",
    desc: "A Signature look that lights the away, leaving an indelible impressive.",
  },
  {
    title: "67.62 cm (26.62”) Dual Panoramic Display Panel",
    desc: "Let the sunshine in! A wide, stunning view that brightens every family ride.",
  },
  {
    title: "Floating Console with Premium Sliding Cover & Cup Holder ",
    desc: "Carry your world, wherever you go, with an elegant storage that moves ith you.",
  },
  {
    title: "Double D-Cut Steering Wheel",
    desc: "Designed to feel as good as it looks sharp,stylish and always in control",
  },
  {
    title: "Paddle Shifters for i-Pedal & Regenerative braking",
    desc: "Smooth intuitive and smart. Reclaim energy every time you slow down.",
  },

  {
    title: "BOSE Premum Sound System with 8 Speakers",
    desc: "Turn every family drive into a concent on wheels with immersive sound that brings everyone together.",

  }, {
    title: "Shift By Wire-Column Type",
    desc: "Charging gear position simply by turning the dail of shift-by-wire left or right.",
  }, {
    title: "64 Color Ambient Lighting & Footwell Lamp",
    desc: "illuminate the cabin to match your mood from night to day.",
  },
];

export { BannerData, caroData, CircleData, TrimData, DetailInfo, caro3in1Data, gridData, com3struct, Caro3Heading, FaqData, StepData };